import { Link, useParams } from "react-router-dom";

export default function ArchiveSeasonHome() {
    const { seasonKey } = useParams();
    const key = String(seasonKey || "").trim();
    const title = key ? key.toUpperCase() : "SEASON";

    const cards = [
        {
            to: `/gt3x/archiv/${key}/standings/pro`,
            title: "Standings",
            pillClass: "pill--pro",
            pillText: "PRO",
            sub: `Archivierte PRO-Gesamtwertung (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/standings/int`,
            title: "Standings",
            pillClass: "pill--int",
            pillText: "INT",
            sub: `Archivierte INT-Gesamtwertung (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/standings/am`,
            title: "Standings",
            pillClass: "pill--am",
            pillText: "AM",
            sub: `Archivierte AM-Gesamtwertung (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/standings/team`,
            title: "Standings",
            pillClass: "pill--team",
            pillText: "TEAM",
            sub: `Archivierte Teamwertung (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/standings/marke`,
            title: "Standings",
            pillClass: "pill--marke",
            pillText: "MARKE",
            sub: `Archivierte Markenwertung (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/results`,
            title: "Ergebnisse",
            pillClass: "pill--int",
            pillText: "RACEDAY",
            sub: `Archivierte Race-, Qualy- und Practice-Ergebnisse (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/incidents`,
            title: "Incidents",
            pillClass: "pill--team",
            pillText: "REKO",
            sub: `Archivierte Incident- und Protest-Entscheidungen (${title})`,
        },
        {
            to: `/gt3x/archiv/${key}/lizenz`,
            title: "Fahrerlizenz",
            pillClass: "pill--pro",
            pillText: "LIZENZ",
            sub: `Archivierte Lizenzpunkte und Strafstatus (${title})`,
        },
    ];

    return (
        <>
            <div className="card overview-card-top">
                <h1>Archiv - {title}</h1>
                <p className="muted results-subtitle">
                    Auswahl der archivierten Standings, Rennergebnisse, Incidents und Fahrerlizenz.
                </p>
            </div>

            <div className="grid4">
                {cards.map((card) => (
                    <Link key={card.to} to={card.to} className="grid-card" style={{ textDecoration: "none" }}>
                        <div className="grid-card__info">
                            <div className="grid-card__title">
                                {card.title} <span className={`pill ${card.pillClass}`}>{card.pillText}</span>
                            </div>
                            <div className="grid-card__sub">{card.sub}</div>
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
}
